/* eslint-disable react/forbid-prop-types,react/require-default-props,jsx-a11y/anchor-has-content */

import { Link as RudyLink, RudyConsumer } from '@respond-framework/react';
import { actionToUrl } from '@respond-framework/rudy';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { makeRoutesMapForOrigin } from '../../../ReduxStorage/routesHelpers';
import { multiDomainRoutesMap } from '../../../ReduxStorage/routesMap';

// the props are the same as RFRLink i.e. not immutable.
// eslint-disable-next-line react/prefer-stateless-function
class LinkInnerInner extends Component {
  static propTypes = {
    /*
      Props that only work for RFR/SPA links

      eg. props = {
        to: {
          // action type
          type: ROUTE_COURSE_PAGE,
          // URL path params as object
          params: {
            courseCode: '...',
          },
          // URL query params as object
          query: {
            cohortPath: '...',
          },
        },
      };

      @see https://github.com/faceyspacey/redux-first-router/blob/master/docs/query-strings.md
    */
    rudyApi: PropTypes.object,
    to: PropTypes.object, // Only actions are allowed!
    currentOrigin: PropTypes.string.isRequired,
    redirect: PropTypes.bool,
    destinationOrigin: PropTypes.string,
    destinationPath: PropTypes.string,
    down: PropTypes.bool,
    shouldDispatch: PropTypes.bool,

    // Not supported
    /**
     * tagName
     * replace (use redirect)
     */

    // Props that work with both SPA links and the <a /> tag
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
      PropTypes.string,
    ]),
    onPress: PropTypes.func,
    onClick: PropTypes.func,
    target: PropTypes.string,
    rel: PropTypes.string,
    className: PropTypes.string,
  };

  render() {
    const {
      rudyApi,
      to,
      redirect,
      down,
      shouldDispatch,
      currentOrigin,
      destinationOrigin,
      ...otherProps
    } = this.props;

    const toWithInstitutionPrefix = {
      ...to,
      params: {
        ...to.params,
        institutionPrefix: (to.state || {}).institutionPrefix,
      },
    };

    let destinationPath;
    if (destinationOrigin) {
      const destinationRoutesMap = makeRoutesMapForOrigin(
        {
          [to.type]: multiDomainRoutesMap[to.type],
        },
        destinationOrigin
      );
      try {
        destinationPath = actionToUrl(toWithInstitutionPrefix, {
          ...rudyApi,
          routes: destinationRoutesMap,
        }).url;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(
          '<Link />: Failed to create path for routing action',
          to,
          destinationRoutesMap,
          destinationOrigin
        );
        // eslint-disable-next-line no-console
        console.error(err);
        destinationPath = null;
      }
    } else {
      // eslint-disable-next-line no-console
      console.warn('<Link />: Failed to select origin for routing action', to);
      destinationPath = null;
    }

    if (!destinationOrigin || !destinationPath) {
      return null;
    } else if (destinationOrigin !== currentOrigin) {
      return (
        <a href={`${destinationOrigin}${destinationPath}`} {...otherProps} />
      );
    } else {
      return (
        <RudyLink
          {...{ to: toWithInstitutionPrefix, redirect, down, shouldDispatch }}
          {...otherProps}
        />
      );
    }
  }
}

export const LinkInner = (props) => (
  <RudyConsumer>
    {(rudyApi) => <LinkInnerInner {...{ ...props, rudyApi }} />}
  </RudyConsumer>
);
